export interface PageMeta {
  title: string;
  subtitle?: string;
}

/** Ordem importa: rotas mais específicas primeiro quando o prefixo colide com outra. */
const PAGE_META: Array<{ match: (path: string) => boolean } & PageMeta> = [
  { match: (p) => p === "/dashboard", title: "Dashboard", subtitle: "Visão geral do atendimento" },
  { match: (p) => p.startsWith("/tickets"), title: "Tickets", subtitle: "Chamados abertos pelos seus clientes" },
  { match: (p) => p.startsWith("/conversations"), title: "WhatsApp", subtitle: "Conversas em andamento" },
  {
    match: (p) => p.startsWith("/companies"),
    title: "Empresas",
    subtitle: "Empresas e projetos atendidos pela sua organização",
  },
  { match: (p) => p.startsWith("/clients"), title: "Pessoas", subtitle: "Contatos com acesso ao portal do cliente" },
  {
    match: (p) => p.startsWith("/channels") || p.startsWith("/whatsapp-settings"),
    title: "Canais",
    subtitle: "Integrações de atendimento",
  },
  { match: (p) => p.startsWith("/teams"), title: "Equipes", subtitle: "Times de atendimento" },
  { match: (p) => p.startsWith("/agents"), title: "Agentes", subtitle: "Usuários com acesso ao painel" },
  { match: (p) => p.startsWith("/knowledge-base"), title: "Base de Conhecimento", subtitle: "Artigos usados pela IA" },
  { match: (p) => p.startsWith("/assinatura"), title: "Assinatura", subtitle: "Plano e faturamento" },
  { match: (p) => p.startsWith("/profile"), title: "Meu Perfil" },
  { match: (p) => p.startsWith("/settings"), title: "Configurações", subtitle: "Preferências da organização" },
];

export function getPageMeta(pathname: string): PageMeta {
  return PAGE_META.find((m) => m.match(pathname)) || { title: "BaitaTicket" };
}
